<script>
import UiNavbarItem from "@/components/ui/NavbarItem";

export default {
  name: "NavbarMenu",
  components: { UiNavbarItem },
  props: {
    links: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<template>
  <ul class="list-unstyled text-gray-500">
    <UiNavbarItem v-for="item in links" :item="item" :key="item.label" />
  </ul>
</template>
